import script from "./ActivityRequestQuickViews.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityRequestQuickViews.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__